'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ISOPackager2 = require('./ISOPackager');

var _ISOPackager3 = _interopRequireDefault(_ISOPackager2);

var _ISOBitMapPackager = require('./packer/ISOBitMapPackager');

var _ISOBitMapPackager2 = _interopRequireDefault(_ISOBitMapPackager);

var _ISOFieldPackager = require('./packer/ISOFieldPackager');

var _ISOFieldPackager2 = _interopRequireDefault(_ISOFieldPackager);

var _ISOMsgFieldPackager = require('./packer/ISOMsgFieldPackager');

var _ISOMsgFieldPackager2 = _interopRequireDefault(_ISOMsgFieldPackager);

var _ISOBitMap = require('./ISOBitMap');

var _ISOBitMap2 = _interopRequireDefault(_ISOBitMap);

var _ISOComponent = require('./ISOComponent');

var _ISOComponent2 = _interopRequireDefault(_ISOComponent);

var _ISOMsg = require('./ISOMsg');

var _ISOMsg2 = _interopRequireDefault(_ISOMsg);

var _ISOUtil = require('./ISOUtil');

var _ISOUtil2 = _interopRequireDefault(_ISOUtil);

var _Arrays = require('jsdk/util/Arrays');

var _Arrays2 = _interopRequireDefault(_Arrays);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author Sean sean.snow@live.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @date 2015/12/25
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ISOBasePackager = function (_ISOPackager) {
    _inherits(ISOBasePackager, _ISOPackager);

    function ISOBasePackager() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ISOBasePackager);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ISOBasePackager.__proto__ || Object.getPrototypeOf(ISOBasePackager)).call.apply(_ref, [this].concat(args))), _this), _this.fld = [], _this.realm = null, _this.headerLength = 0, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ISOBasePackager, [{
        key: 'setFieldPackager',
        value: function setFieldPackager(fld) {
            this.fld = fld;
        }
    }, {
        key: 'emitBitMap',
        value: function emitBitMap() {
            return this.fld[1] instanceof _ISOBitMapPackager2.default;
        }

        /**
         * usually 2 for normal fields, 1 for bitmap-less
         * or ANSI X9.2
         * @return Number first valid field
         */

    }, {
        key: 'getFirstField',
        value: function getFirstField() {
            if (!(this.fld[0] instanceof _ISOMsgFieldPackager2.default) && this.fld.length > 1) {
                return this.fld[1] instanceof _ISOBitMapPackager2.default ? 2 : 1;
            }

            return 0;
        }
    }, {
        key: 'getBitMapfieldPackager',
        value: function getBitMapfieldPackager() {
            return this.fld[1];
        }
    }, {
        key: 'pack',
        value: function pack(m) {
            if (m.getComposite() != m) {
                throw Error('Can\'t call packager on non Composite');
            }

            var v = [];
            var fields = m.getChildren();
            var len = 0;
            var first = this.getFirstField();
            var c = fields[0];
            var b = [];
            if (m instanceof _ISOMsg2.default && this.headerLength > 0) {
                var h = m.getHeader();
                if (h != null) {
                    len += h.length;
                }
            }
            if (first > 0 && c != null) {
                b = this.fld[0].pack(c);
                len += b.length;
                v.push(b);
            }

            if (this.emitBitMap()) {
                c = fields[-1];
                b = this.getBitMapfieldPackager().pack(c);
                len += b.length;
                v.push(b);
            }
            // if Field 1 is a BitMap then we are packing an
            // ISO-8583 message so next field is fld#2.
            // else we are packing an ANSI X9.2 message, first field is 1
            var tmpMaxField = Math.min(m.getMaxField(), 128);

            for (var i = first; i <= tmpMaxField; i++) {
                if ((c = fields[i]) != null) {
                    var fp = this.fld[i];
                    if (fp == null) {
                        throw Error('null field ' + i + ' packager');
                    }
                    b = fp.pack(c);
                    len += b.length;
                    v.push(b);
                }
            }

            if (m.getMaxField() > 128 && this.fld.length > 128) {
                for (var _i = 1; _i <= 64; _i++) {
                    if ((c = fields[_i + 128]) != null) {
                        b = this.fld[128 + _i].pack(c);
                        len += b.length;
                        v.push(b);
                    }
                }
            }

            var k = 0;
            var d = new Array(len);

            //if ISOMsg insert header
            if (m instanceof _ISOMsg2.default && this.headerLength > 0) {
                var _h = m.getHeader();
                if (_h != null) {
                    _Arrays2.default.arraycopy(_h, 0, d, k, _h.length);
                    k += _h.length;
                }
            }

            v.forEach(function (bb) {
                _Arrays2.default.arraycopy(bb, 0, d, k, bb.length);
                k += bb.length;
            });

            return d;
        }
    }, {
        key: 'unpack',
        value: function unpack(m, b) {
            var consumed = 0;
            if (m.getComposite() !== m) {
                throw Error('Can\'t call packager on non Composite');
            }

            if (m instanceof _ISOMsg2.default) {
                var h = new Array(this.headerLength);
                _Arrays2.default.arraycopy(b, 0, h, 0, this.headerLength);
                m.setHeader(h);
                consumed += this.headerLength;
            }

            if (!(this.fld[0] == null) && !(this.fld[0] instanceof _ISOBitMapPackager2.default)) {
                var mti = this.fld[0].createComponent(0);
                consumed += this.fld[0].unpack(mti, b, consumed);
                m.set(mti);
            }

            var bmap = null;
            var maxField = this.fld.length;
            if (this.emitBitMap()) {
                var bitmap = new _ISOBitMap2.default(-1);
                consumed += this.getBitMapfieldPackager().unpack(bitmap, b, consumed);
                bmap = bitmap.getValue();
                m.set(bitmap);
                maxField = Math.min(maxField, bmap.size());
            }

            for (var i = this.getFirstField(); i < maxField; i++) {
                if (bmap == null && this.fld[i] == null) {
                    continue;
                }

                if (maxField > 128 && i === 65) {
                    continue;
                }

                if (bmap == null || bmap.get(i)) {
                    if (this.fld[i] == null) {
                        throw Error('field packager ' + i + ' is null.');
                    }
                    var c = this.fld[i].createComponent(i);
                    consumed += this.fld[i].unpack(c, b, consumed);
                    m.set(c);
                }
            }
        }
    }, {
        key: 'getFieldDescription',
        value: function getFieldDescription(m, fldNumber) {
            return this.fld[fldNumber].getDescription();
        }
    }, {
        key: 'getFieldPackager',
        value: function getFieldPackager(fldNumber) {
            return this.fld != null && fldNumber < this.fld.length ? this.fld[fldNumber] : null;
        }
    }, {
        key: 'createISOMsg',
        value: function createISOMsg() {
            var msg = new _ISOMsg2.default();
            msg.setPackager(this);
            return msg;
        }
    }]);

    return ISOBasePackager;
}(_ISOPackager3.default);

exports.default = ISOBasePackager;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jspos/lib/ISOBasePackager.js
// module id = 36
// module chunks = 0